if (!customElements.get('momento-homepage-story')) {
  class MomentoHomepageStory extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.video = this.querySelector('video');
      if (!this.video) return;

      this.abortController = new AbortController();
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktopPreference = window.matchMedia('(min-width: 1024px)');
      this.nearViewport = false;
      this.motionAllowed = false;

      this.syncSource = () => {
        this.video.load();
        if (this.nearViewport && this.motionAllowed) this.playVideo();
      };

      this.syncMotion = () => {
        this.motionAllowed = !this.motionPreference.matches;
        this.video.autoplay = this.motionAllowed;

        if (!this.motionAllowed) this.video.pause();
        else if (this.nearViewport) this.playVideo();
      };

      this.observer = new IntersectionObserver(([entry]) => {
        this.nearViewport = entry.isIntersecting;

        if (this.nearViewport && this.motionAllowed) this.playVideo();
        else if (!this.nearViewport) this.video.pause();
      }, {
        rootMargin: '480px 0px',
        threshold: 0.01,
      });

      this.video.addEventListener('canplay', () => {
        if (this.nearViewport && this.motionAllowed) this.playVideo();
      }, { signal: this.abortController.signal });
      this.motionPreference.addEventListener('change', this.syncMotion, {
        signal: this.abortController.signal,
      });
      this.desktopPreference.addEventListener('change', this.syncSource, {
        signal: this.abortController.signal,
      });

      this.syncMotion();
      this.observer.observe(this.video);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
      this.video?.pause();
      this.abortController = null;
    }

    playVideo() {
      const playPromise = this.video?.play();
      if (playPromise?.catch) playPromise.catch(() => {});
    }
  }

  customElements.define('momento-homepage-story', MomentoHomepageStory);
}
